/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./fieldList.js"),n={};n.undefined=t=>t;const l=(t,e)=>e&&e.arrays&&!isNaN(Number(t))?[]:{};function d(t){if(n[t])return n[t];const e=a.fieldList(t);return n[t]=(u,c,i)=>{let r=u;const o=e.length-1;for(let s=0;s<o&&r;s++)r=r[e[s]]=r[e[s]]||l(e[s+1],i);r[e[o]]=c},n[t]}exports.setter=d;
